import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "py-6 text-sm text-gray-500"
}
const _hoisted_2 = {
  key: 1,
  class: "py-6 text-sm text-gray-500"
}
const _hoisted_3 = {
  key: 2,
  class: "py-4"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "mt-2 text-sm text-gray-600" }
const _hoisted_6 = { class: "mt-4 grid grid-cols-3 gap-4 border-t border-gray-100 pt-4" }
const _hoisted_7 = { class: "text-sm text-gray-900" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "text-sm text-gray-900" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "text-sm text-gray-900" }
const _hoisted_12 = ["href"]

import {
		ArrowTopRightOnSquareIcon
	} from "@heroicons/vue/24/outline"

	import {
		ref
	} from "vue"

	import api from "@/utilities/api"

	
	const __default__ = { name: "WebinarModal" } // name the component

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {

	const dateFormatter = new Intl.DateTimeFormat("en-US", {
		year: "numeric",
		month: "long",
		day: "numeric"
	})

	const modal = ref<{open: boolean}>({open: false})
	const loading = ref(false)
	const error = ref(false)
	const webinar = ref<{
		title: string,
		description: string,
		date: string,
		permalink: string,
		speaker: string | null,
		topics: string | null,
		replayUrl: string | null
	} | null>(null)

	// reveal the modal and (re)fetch the most recently published webinar entry
	function open() {
		modal.value.open = true
		getLatestWebinar()
	}

	// fetch the most recent webinar entry from the backend and format it for display
	async function getLatestWebinar() {
		loading.value = true
		error.value = false

		try {
			const response = await api("get", "fmDataAPI", "/webinar-latest")

			if (!response.webinar) {
				error.value = true
				return
			}

			webinar.value = {
				...response.webinar,
				date: dateFormatter.format(new Date(response.webinar.date))
			}
		}
		catch(e) {
			error.value = true
		}
		finally {
			loading.value = false
		}
	}

	__expose({
		open
	})

return (_ctx: any,_cache: any) => {
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createBlock(_component_tw_modal, {
    title: "Latest Webinar",
    "modal-max-width": "max-w-md",
    ref_key: "modal",
    ref: modal
  }, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Loading... "))
        : (error.value || !webinar.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Unable to load webinar details right now. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("a", {
                href: webinar.value.permalink,
                target: "_blank",
                rel: "noopener noreferrer",
                class: "inline-flex items-center gap-1 text-base font-semibold text-indigo-600 hover:text-indigo-800"
              }, [
                _createTextVNode(_toDisplayString(webinar.value.title) + " ", 1),
                _createVNode(_unref(ArrowTopRightOnSquareIcon), { class: "h-4 w-4 shrink-0" })
              ], 8, _hoisted_4),
              _createElementVNode("p", _hoisted_5, _toDisplayString(webinar.value.description), 1),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("span", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-400" }, "When", -1)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(webinar.value.date), 1)
                ]),
                (webinar.value.speaker)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-400" }, "Speaker", -1)),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(webinar.value.speaker), 1)
                    ]))
                  : _createCommentVNode("", true),
                (webinar.value.topics)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "block text-xs font-semibold uppercase tracking-wide text-gray-400" }, "Topics", -1)),
                      _createElementVNode("span", _hoisted_11, _toDisplayString(webinar.value.topics), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (webinar.value.replayUrl)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: webinar.value.replayUrl,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    class: "mt-6 flex w-full items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-semibold text-white hover:bg-indigo-500"
                  }, " Watch Replay ", 8, _hoisted_12))
                : _createCommentVNode("", true)
            ]))
    ]),
    _: 1
  }, 512))
}
}

})